import { useMutation } from "@tanstack/react-query";

import { useAuth } from "../../../shared/contexts/auth/useAuth.ts";

// oxlint-disable-next-line @typescript-eslint/explicit-function-return-type
export function useMaintenanceActions() {
  const { api } = useAuth();
  const backfillMediaPreviews = useMutation({
    mutationFn: api.maintenance.backfillMediaPreviews,
  });

  return { backfillMediaPreviews };
}
